module.exports = __webpack_public_path__ + "static/img/realTime.8c0b31f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Help/realTime.gif
// module id = 0COK
// module chunks = 3